import { hideFullOptions } from 'owa-options-core/lib/actions/publicActions';
import { updateHeaderButtonState } from 'owa-suite-header-apis';
import { orchestrator } from 'satcheljs';
import { OwaPremiumButtonID } from '../constants';

orchestrator(hideFullOptions, () => updateHeaderButtonState(OwaPremiumButtonID, false));
